import axios from 'axios';

export function exportExcel(url, name) {
  axios.get(url, {
    headers: {
      "Content-Type": "application/octet-stream",
      "Accept": "application/octet-stream"
    },
    responseType: "blob"
  }).then(response => {
    const a = document.createElement("a");
    const url = window.URL.createObjectURL(response.data);
    a.href = url;
    a.download = name;
    a.click();
  })
  .catch(err => {
    console.error("error", err);
  });
};


// WEBPACK FOOTER //
// ./src/constants/exportExcel.js